import {GlobalVariables} from "../GlobalVariables";

export default class Buttons {
	static init() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke, .btn-light");

		this.buttons.forEach( (button) => {

			const text = `<span class='label'>${button.innerHTML}</span>`;
			button.innerHTML = text;

			if( button.classList.contains('btn-go') || button.classList.contains('btn-back') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="50" height="54" viewBox="0 0 50 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.7803 49.6981L23.5981 53.5714L50 26.7857L23.5981 0L19.7803 3.87236L39.6649 24.046L0 24.046L0 29.5239L39.6649 29.5239L19.7803 49.6981Z" fill="currentColor"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-download') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-gallery') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-lang') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

		});

		this.buttonCTAForm();
		this.positionTooltip();
		GlobalVariables.resizeCallbacks.push(this);

	}

	static buttonCTAForm(){

		let buttonsOpen = document.querySelectorAll('.js-cta-form');
		let buttonsClose = document.querySelectorAll('.js-form-close');
		let sidebar = document.querySelector('.sidebar');
		let firstInput = sidebar.querySelector('input[type="text"]');
		let immoleadIDInput = sidebar.querySelector('input[name="input_14"]');
		let lotNumberInput = sidebar.querySelector('input[name="input_20"]');

		buttonsOpen.forEach( (button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.add('sidebar-open');
				firstInput.focus();
				immoleadIDInput.value = "";
				if( button.dataset.immoleadId ){
					immoleadIDInput.value = button.dataset.immoleadId;
				}
				lotNumberInput.value = "";
				if( button.dataset.lotNumber ){
					lotNumberInput.value = button.dataset.lotNumber;
				}
				if( button.classList.contains('js-cta-lot') ){
					this.toolTip.querySelector('.lot').style.display = "block";
					this.toolTip.querySelector('.generic').style.display = "none";
				} else {
					this.toolTip.querySelector('.lot').style.display = "none";
					this.toolTip.querySelector('.generic').style.display = "block";
				}
				this.toolTip.classList.add('active');
			});
		});

		buttonsClose.forEach( (button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.remove('sidebar-open');
				this.toolTip.classList.remove('active');
			});
		});

	}

	static positionTooltip(){

		let sidebar = document.querySelector('.sidebar');
		let sidebarContainer = sidebar.querySelector('.sidebar-container');
		let firstInput = sidebar.querySelector('input[type="text"]');
		let firstInputPosition = firstInput.getBoundingClientRect();
		this.toolTip = sidebar.querySelector('.sidebar-tooltip');
		this.toolTip.style.top = ( firstInputPosition.top + (firstInput.offsetHeight/2) ) + "px";
		this.toolTip.style.right = sidebarContainer.offsetWidth + "px";

		if( window.innerWidth < 992 ){
			this.toolTip.classList.remove('active');
		} else if ( window.innerWidth > 991 && document.body.classList.contains('sidebar-open') ){
			this.toolTip.classList.add('active');
		}

	}

	static resize(){
		this.positionTooltip();
	}

}
